/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 */

import { Navigate } from "react-router-dom";
import { useBilling } from "../hooks/useBilling.js";

export default function RequireBilling({ children }) {
  const { loading, billingActive, error, refresh } = useBilling();
  if (loading) return <p className="muted">Loading...</p>;

  // A failed billing read used to render the raw error string as the entire
  // page — no heading, no way out, and nothing telling the user whether their
  // account was broken or ours was. It isn't an account problem: billing state
  // simply couldn't be read, which is almost always transient. Say that, and
  // give them a way forward.
  if (error) {
    return (
      <div className="auth-wrap">
        <section className="auth-card">
          <h1>We couldn't check your subscription</h1>
          <p className="auth-sub">
            This is a problem on our end, not with your account — nothing has changed
            about your plan. It's usually temporary.
          </p>
          <button className="btn" onClick={refresh}>Try again</button>
          <p className="auth-foot muted">
            Still stuck? <a className="link" href="/help">Contact support</a>
          </p>
        </section>
      </div>
    );
  }

  if (!billingActive) return <Navigate to="/subscribe" replace />;
  return children;
}
